/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Address_RequiredInputs */

const cs_validation_address_required = /** @type {(inputs: Validation_Address_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa je povinná`)
};

const en_validation_address_required = /** @type {(inputs: Validation_Address_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address is required`)
};

/**
* | output |
* | --- |
* | "Address is required" |
*
* @param {Validation_Address_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_address_required = /** @type {((inputs?: Validation_Address_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Address_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_address_required(inputs)
	return cs_validation_address_required(inputs)
});